export default "__VITE_ASSET__gyPBOVjJ__"